import {
	AddHeaderFooter,
	Parameter
} from "@softvision/webpdf-wsclient-9-typescript/lib/generated-sources";
import FunctionHelper from "../helper/FunctionHelper";
import {PortalHeaderFooter} from "./PortalHeaderFooter";

export class PortalAddHeaderFooter extends AddHeaderFooter
	implements Parameter {
	constructor(data: any) {
		super(data);

		this.headerFooterContent = PortalHeaderFooter.fromJson(data?.headerFooterContent);
	}

	public static fromJson(data: any): PortalAddHeaderFooter {
		if (!FunctionHelper.exists(data)) {
			return data;
		}

		return new PortalAddHeaderFooter(data);
	}

	public clone(): PortalAddHeaderFooter {
		return PortalAddHeaderFooter.fromJson(this.toJson());
	}
}